var en = {
    translation: {
        button: {
            backToAccountManager: 'Back to account manager',
            requestRefundCheck: 'Request Refund Check',
            back: 'Back',
            submit: 'Submit',
            manageProfile: 'Manage Profile'
        },
        text: {
            startAChat: 'start a chat',
            requestARefund: 'To find out how you can request a refund, please ',
            requestSubmitted: 'Refund Request Submitted',
            requestInProgress: 'Refund Request In Progress',
            requestRefundCheck: 'Your account should be updated with your refund request within 24 hours. You’ll receive your refund check within {{duration}}.',
            duration: '7 to 15 business days',
            requestRefundThankYou: 'Thanks for your request.',
            amount: 'Amount',
            address: 'Address',
            wrongAddress: "Wrong address? Update it in <manageProfileLink>{{manageProfileLinkText}}</manageProfileLink></br> and then restart your\n      refund request."
        },
        error: {
            header: 'Sorry, something went wrong.',
            subText: 'Please close this page and try again later.'
        },
        title: {
            manageBalanceOption: 'Manage Your Credit Balance'
        },
        header: {
            theseOptionsText: 'these options',
            theOptionText: 'the option',
            applyCurrentBalance: 'Please review {{optionText}} on your balance of {{currentBalance}}.',
            applyNextPurchase: 'Save your credit for a future purchase',
            requestRefundCheck: 'Request a refund check',
            reviewRefundRequest: 'Review your refund request before submitting.'
        },
        subtext: {
            receiveRefundCheck: "We'll verify your address and send you a check within 7 to 15 business days.",
            applyCurrentBalanceAutomatically: 'Your current balance will be applied automatically to your next purchase.'
        },
        mocks: {
            beginLogin: 'Begin Login',
            logout: 'Logout',
            clientId: 'Enter a Client ID',
            environment: 'Choose an Environment',
            accountEnding: 'Account ending in {{accountLast4}}',
            cardAccountEnding: 'Card for account ending in {{accountLast4}}',
            currentBalance: 'Current Balance',
            availableToSpend: 'Available to spend',
            totalMinimumPayment: 'Total Minimum Payment',
            paymentDueDate: 'Payment Due Date',
            makeAPayment: 'Make a Payment'
        },
        logout: {
            pageTitle: 'Logged Out',
            cardTitle: 'Thank you for managing your Synchrony accounts.',
            cardDescription: "You've securely logged out.",
            button: 'LOG BACK IN'
        }
    }
};
export default en;
